import { Select, Tag, Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';

import { PermissionEnum } from 'src/api-sdk';

const PERMISSION_TAG_COLOR: Record<PermissionEnum, string | undefined> = {
  [PermissionEnum.ViewOnly]: undefined,
  [PermissionEnum.Write]: 'blue',
  [PermissionEnum.Admin]: 'purple',
  [PermissionEnum.Owner]: 'gold',
};

export const PermissionTag = ({
  permission,
}: {
  permission: PermissionEnum;
}) => {
  const { t } = useTranslation('permissions');
  const labels: Record<PermissionEnum, string> = {
    [PermissionEnum.ViewOnly]: t('View only'),
    [PermissionEnum.Write]: t('Write'),
    [PermissionEnum.Admin]: t('Admin'),
    [PermissionEnum.Owner]: t('Owner'),
  };

  return (
    <Tag color={PERMISSION_TAG_COLOR[permission]}>{labels[permission]}</Tag>
  );
};

const PermissionOptionSelect = ({
  value,
  entity,
  onChange,
  disabled,
  allowClear,
  placeholder,
}: {
  value?: string;
  entity: string;
  onChange?: (value: string | null) => void;
  disabled?: boolean;
  allowClear?: boolean;
  placeholder?: string;
}) => {
  const { t } = useTranslation('permissions');

  return (
    <Select
      onChange={(value, option) => {
        if (onChange) {
          onChange(value ?? null);
        }
      }}
      value={value}
      disabled={disabled}
      allowClear={allowClear}
      placeholder={placeholder}
    >
      <Select.Option
        key={PermissionEnum.ViewOnly}
        value={PermissionEnum.ViewOnly}
      >
        <Tooltip
          title={
            entity === 'portfolio'
              ? t('Only access to use the portfolio')
              : t('Only access to read the binder')
          }
        >
          {t('View only')}
        </Tooltip>
      </Select.Option>
      <Select.Option key={PermissionEnum.Write} value={PermissionEnum.Write}>
        <Tooltip
          title={
            entity === 'portfolio'
              ? t('Access to use the portfolio and add new companies')
              : t('Access to use the binder and add new articles')
          }
        >
          {t('Write')}
        </Tooltip>
      </Select.Option>
      <Select.Option key={PermissionEnum.Admin} value={PermissionEnum.Admin}>
        <Tooltip
          title={
            entity === 'portfolio'
              ? t('Use, edit and administrate the portfolio')
              : t('Use, edit and administrate the binder')
          }
        >
          {t('Admin')}
        </Tooltip>
      </Select.Option>
      <Select.Option key={PermissionEnum.Owner} value={PermissionEnum.Owner}>
        <Tooltip
          title={
            entity === 'portfolio'
              ? t('Owner of the portfolio')
              : t('Owner of the binder')
          }
        >
          {t('Owner')}
        </Tooltip>
      </Select.Option>
    </Select>
  );
};

export default PermissionOptionSelect;
